import { AxiosInstanceBuilder } from '@digibricks/plugin-axios';
import { IDENTITY_REPOSITORY_WEB_CONFIG } from './identity-repository-web.config';
import { AUTH_API, AuthApi, USER_API, UserApi } from './data-sources';
export var apiProviders = [{
  provide: AxiosInstanceBuilder,
  useFactory: function useFactory(config) {
    return new AxiosInstanceBuilder().withBaseUrl(config.baseUrl).withTimeout(config.timeout).withHeaders({
      Authorization: "Bearer ".concat(config.accessToken)
    });
  },
  inject: [IDENTITY_REPOSITORY_WEB_CONFIG]
}, {
  provide: AUTH_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new AuthApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: USER_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new UserApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}];